import * as Flash from 'components/flash'
import { HeaderComponent } from 'components/header/component'
import { preventDefaultThen } from 'components/link'
import { Loading } from 'components/loading'
import { RasaContext } from 'context'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import * as GenericRedux from 'generic/genericRedux'
import capitalize from 'lodash/capitalize'
import React, { Component } from 'react'
import { Button, Col, Row, Input } from 'reactstrap'
import * as Redux from 'redux'
import { injectReducer } from 'store/index'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { DateTimeCell } from 'components/gridcells/datetime'
import { EditCellProps} from 'generic/editCell'

import './_styles.scss'
import * as Constants from './constants'
import * as Types from './types'

class ActivityReportComponent extends Component<Types.Props, Types.State> {
  public static contextType = RasaContext

  constructor(props: Types.Props) {
    super(props)
    this.state = {
      data: {
        articles: [],
        images: [],
        source_run: [],
        last_issue: {},
        message: '',
        schedule: {},
        schedule_history: [],
        success: true,
        upcoming_issue: {},
      },
      error: '',
      isLoading: true,
      selectedCommunity: '',
      url: '',
      reportType: Constants.ActivityType.ARTICLE_ACTIVITY,
    }
  }

  public componentDidMount = () => {
    this.context.user.init().then(({person, activeCommunity}) => {
      this.setState({
        isLoading: false,
        selectedCommunity: activeCommunity.communityId,
      })
    })
  }

  public render() {
    return <div className="activity-report-wrapper">
      <HeaderComponent
        title={'ACTIVITY'}
        subTitle={'Activity Report'}
        description={[
          'Review activity of your newsletter.'
        ]}/>
      {this.state.isLoading ?
        <Loading size="64"/>
      :
        <div>
          <div className="ar-form-wrap">
            <div className="ar-form-row">
              <label>Activity Type</label>
              <Input
                type="select"
                value={this.state.reportType}
                onChange={(e: any) => this.handleReportTypeChange(e.target.value as Constants.ActivityType)}
                className="activity-type-select"
              >
                {Object.entries(Constants.ACTIVITY_TYPE_OPTIONS).map(([key, value]) => (
                  <option key={key} value={key}>{value}</option>
                ))}
              </Input>
            </div>
            {this.renderInputForm()}
          </div>
          {this.state.error.length
          ? <span className="warning" dangerouslySetInnerHTML={{__html: this.state.error || 'We could not locate a feed for this URL'}} />
          : this.renderActivity()
          }
        </div>
      }
    </div>
  }

  private renderInputForm = () => {
    switch (this.state.reportType) {
      case Constants.ActivityType.ARTICLE_ACTIVITY:
        return this.renderArticleInputForm()
      case Constants.ActivityType.IMAGE_ACTIVITY:
        return this.renderImageInputForm()
      case Constants.ActivityType.SOURCE_HISTORY:
        return this.renderSourceInputForm()
      case Constants.ActivityType.SCHEDULE_HISTORY:
        return null // Schedule history doesn't need input form
      default:
        return null
    }
  }

  private renderArticleInputForm = () => {
    return (
      <div className="ar-form-row">
        <label>Article URL</label>
        <form onSubmit={preventDefaultThen(() => this.getArticleActivity())}>
          <input autoFocus disabled={this.state.isLoading} className="field-textbox"
            placeholder="Enter the URL to review"
            value={this.state.url}
            onChange={(e: any) => this.setState({ url: e.target.value })}
          />
          <Button className='ar-form-btn' disabled={this.state.url.length === 0} >Get Activity</Button>
        </form>
      </div>
    )
  }

  private renderImageInputForm = () => {
    return (
      <div className="ar-form-row">
        <label>Image URL</label>
        <form onSubmit={preventDefaultThen(() => this.getImageActivity())}>
          <input autoFocus disabled={this.state.isLoading} className="field-textbox"
            placeholder="Enter the image URL to review"
            value={this.state.url}
            onChange={(e: any) => this.setState({ url: e.target.value })}
          />
          <Button className='ar-form-btn' disabled={this.state.url.length === 0} >Get Activity</Button>
        </form>
      </div>
    )
  }

  private renderSourceInputForm = () => {
    return (
      <div className="ar-form-row">
        <label>Source URL</label>
        <form onSubmit={preventDefaultThen(() => this.getSourceHistory())}>
          <input autoFocus disabled={this.state.isLoading} className="field-textbox"
            placeholder="Enter the URL to review"
            value={this.state.url}
            onChange={(e: any) => this.setState({ url: e.target.value })}
          />
          <Button className='ar-form-btn' disabled={this.state.url.length === 0} >Fetch</Button>
        </form>
      </div>
    )
  }

  private renderActivity = () => {
    if (this.state.isLoading || !this.state.data.success) {
      return null
    }

    switch (this.state.reportType) {
      case Constants.ActivityType.ARTICLE_ACTIVITY:
        return this.renderArticleActivity()
      case Constants.ActivityType.SCHEDULE_HISTORY:
        return this.renderScheduleHistory()
      case Constants.ActivityType.IMAGE_ACTIVITY:
        return this.renderImageActivity()
      case Constants.ActivityType.SOURCE_HISTORY:
        return this.renderSourceHistory()
      default:
        return null
    }
  }

  private renderArticleActivity = () => {
    if (!this.state.data.articles.length) {
      return null
    }

    return <div>
      <div><Row className='header-row'><Col><b>Activity for : {this.state.url}</b></Col></Row></div>
      {this.state.data.articles.map((articleActivity: Types.ArticleActivity) => {
        return <div className="article-activity">{this.renderArticleInfo(articleActivity)}</div>
      })}
      {/* {this.renderHistory(this.state.data.schedule_history)} */}
      {/* {this.renderSchedule()} */}
      {/* {this.renderLastIssue()} */}
      {/* {this.renderUpcomingIssue()} */}
    </div>
  }

  private renderScheduleHistory = () => {
    if (!this.state.data.schedule) {
      return null
    }

    return <div>
      {this.renderHistory(this.state.data.schedule_history)}
      {this.renderSchedule()}
      {this.renderLastIssue()}
      {this.renderUpcomingIssue()}
    </div>
  }

  private renderImageActivity = () => {
    if (!this.state.data.images.length) {
      return null
    }

    return <div>
      <div><Row className='header-row'><Col><b>Image Activity for : {this.state.url}</b></Col></Row></div>
      {this.state.data.images.map((imageActivity: Types.ImageActivity, index: number) => {
        return <div key={index} className="image-activity">{this.renderImageInfo(imageActivity)}</div>
      })}
      {/* {this.renderHistory(this.state.data.schedule_history)} */}
      {/* {this.renderSchedule()} */}
      {/* {this.renderLastIssue()} */}
      {/* {this.renderUpcomingIssue()} */}
    </div>
  }

  private renderSourceHistory = () => {
    if (!this.state.data.source_run.length) {
      return null
    }

    return <div>
      <div><Row className='header-row'><Col><b>Source History for : {this.state.url}</b></Col></Row></div>
      <Grid data={this.state.data.source_run} className="analytics-counts-grid" scrollable="none">
        <GridColumn field="created" title="Run Date" cell={DateTimeCell}/>
        <GridColumn field="status" title="Status"/>
        <GridColumn field="number_of_posts" title="# Articles Pulled"/>
        <GridColumn field="file" title="File" cell={this.FileDownloadCell}/>
      </Grid>
    </div>
  }

  private FileDownloadCell = (props: EditCellProps) => {
    return <td>
      <div onClick={() => this.downloadSourceFile(props.dataItem.source_id, props.dataItem.id)}>
        Download File
      </div>
    </td>
  }


  private renderImageInfo = (imageActivity: Types.ImageActivity) => {
    const image = imageActivity.image
    if (!image) return null

    return <div className="image-info">
      <Row className='header-row'>
        <Col><b>Image: </b>{image.id ? image.id : 'N/A'}</Col>
      </Row>
      <Row>
        <Col><b>Hosted Image: </b> {image.hosted_image_url ? image.hosted_image_url : ''}</Col>
      </Row>
      <Row>
        <Col><b>Title: </b> {image.title ? image.title : ''}</Col>
        <Col><b>Image Type: </b> {image.static_image_type_name}</Col>
        <Col><b>Height: </b> {image.image_height}</Col>
        <Col><b>Width: </b> {image.image_width}</Col>
      </Row>
      <Row>
        <Col><b>Start: </b> {image.start_date}</Col>
        <Col><b>End: </b> {image.end_date}</Col>
        <Col><b>Created: </b> {image.created}</Col>
        <Col><b>Updated: </b> {image.updated}</Col>
      </Row>
      <Row>
        <Col><b>Is Active: </b> {image.is_active}</Col>
        <Col><b>Is Scheduled: </b> {image.is_scheduled}</Col>
        <Col><b>Display Type: </b> {image.image_display_type}</Col>
        <Col><b>Parner Code: </b> {image.community_partner_code}</Col>
      </Row>
      {this.renderHistory(imageActivity.scheduled_image_history)}
      {this.renderHistory(imageActivity.static_image_history)}
    </div>
  }

  private renderArticleInfo = (articleActivity: Types.ArticleActivity) => {
    return <div className="article-info">
      <Row className='header-row'>
        <Col><b>Article: </b>{articleActivity.article.id}</Col>
      </Row>
      <Row>
        <Col><b>Created: </b> {articleActivity.article.created}</Col>
        <Col><b>Original Created: </b> {articleActivity.article.original_created}</Col>
        <Col><b>Updated: </b> {articleActivity.article.updated}</Col>
      </Row>
      <Row>
        <Col><b>Is Active: </b> {articleActivity.article.is_active}</Col>
        <Col><b>Boost Level: </b> {articleActivity.article.boost_level}</Col>
        <Col><b>Reserved: </b> {articleActivity.article.is_reserved || 0}</Col>
      </Row>
      <Row>
        <Col><b>Source Type: </b> {articleActivity.article.source_type}</Col>
        <Col><b>Subscription Type: </b> {articleActivity.article.subscription_type}</Col>
        <Col><b>Section Name: </b> {articleActivity.article.section_name || ''}</Col>
      </Row>
      <Row>
        <Col><b>Source Active: </b> {articleActivity.article.subscription_is_active}</Col>
        <Col><b>Source Updated: </b> {articleActivity.article.subscription_updated}</Col>
        <Col></Col>
      </Row>
      {this.renderHistory(articleActivity.history)}
      {this.renderHistory(articleActivity.api_history)}
      {this.renderHistory(articleActivity.updated_history)}
      {this.renderHistory(articleActivity.scheduled_article_history)}
    </div>
  }

  private renderSchedule = () => {
    const schedule = this.state.data.schedule
    if (!schedule.id) {
      return null
    }
    return <div className="schedule">
      <Row className='header-row'><Col><b>Schedule: </b></Col></Row>
      <Row>
        <Col><b>Time: </b> {schedule.time}</Col>
        <Col><b>Cutoff Offset: </b> {(schedule.cutoff_offset || 0) / 60} Hrs.</Col>
        <Col><b>Is Active: </b> {schedule.is_active}</Col>
      </Row>
      <Row>
        <Col><b>Frequency: </b> {schedule.frequency}</Col>
        <Col><b>Days: </b> {schedule.days}</Col>
        <Col><b>Weeks: </b> {schedule.weeks}</Col>
      </Row>
      <Row>
        <Col><b>Timezone: </b> {schedule.timezone}</Col>
        <Col><b>Updated: </b> {schedule.updated}</Col>
        <Col><b>Start Date: </b> {schedule.start_date}</Col>
      </Row>
    </div>
  }

  private renderLastIssue = () => {
    const lastIssue = this.state.data.last_issue
    return <div className="issues">
      <Row className='header-row'><Col><b>Last Issue: </b></Col></Row>
      <Row>
        <Col><b>Date: </b> {lastIssue.send_at}</Col>
        <Col><b>Cutoff: </b> {lastIssue.cutoff}</Col>
        <Col><b>Last Cutoff: </b> {lastIssue.last_cutoff}</Col>
      </Row>
    </div>
  }

  private renderUpcomingIssue = () => {
    const nextIssue = this.state.data.upcoming_issue
    if (!nextIssue.date) {
      return null
    }
    return <div className="issues">
      <Row className='header-row'><Col><b>Next Issue: </b></Col></Row>
      <Row>
        <Col><b>Date: </b> {nextIssue.date}</Col>
        <Col><b>Cutoff: </b> {nextIssue.cutoff}</Col>
        <Col><b>Is Active: </b> {nextIssue.is_active ? '1' : '0'}</Col>
      </Row>
    </div>
  }

  private renderHistory = (history: Types.AuditLog[]) => {
    if (!history.length) {
      return null
    }
    const formatEntityName = (entityName: string) => {
      return entityName
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .split('_')
        .map(word => capitalize(word))
        .join(' ')
    }
    return <div className="history">
      <Row className='header-row'><Col><b>{formatEntityName(history[0].entity_name)} History: </b></Col></Row>
      {(history || []).map((auditLog: Types.AuditLog) => this.renderAuditLog(auditLog))}
    </div>
  }

  private renderAuditLog = (auditLog: Types.AuditLog) => {
    return <ul className="audit-log">
      <li>
        <Row><Col><b>Created: </b> {auditLog.created}</Col></Row>
        <Row><Col><b>Change: </b> {auditLog.change}</Col></Row>
        <Row><Col><b>User: </b> {auditLog.user_email}</Col></Row>
      </li>
    </ul>
  }

  private handleReportTypeChange = (reportType: Constants.ActivityType) => {
    this.setState({
      reportType,
      data: {
        articles: [],
        images: [],
        source_run: [],
        last_issue: {},
        message: '',
        schedule: {},
        schedule_history: [],
        success: true,
        upcoming_issue: {},
      },
      error: '',
      url: '', // TODO remove the hard coded value
    }, () => {
      this.handleReportTypeAction(reportType)
    })
  }

  private handleReportTypeAction = (reportType: Constants.ActivityType) => {
    switch (reportType) {
      case Constants.ActivityType.ARTICLE_ACTIVITY:
        this.handleArticleActivitySelection()
        break
      case Constants.ActivityType.SCHEDULE_HISTORY:
        this.handleScheduleHistorySelection()
        break
      case Constants.ActivityType.IMAGE_ACTIVITY:
        this.handleImageActivitySelection()
        break
      case Constants.ActivityType.SOURCE_HISTORY:
        this.handleSourceHistorySelection()
        break
      default:
        break
    }
  }

  private handleArticleActivitySelection = () => {
    // Article Activity requires manual input, so no automatic action
  }

  private handleScheduleHistorySelection = () => {
    // Schedule History loads automatically
    this.getScheduleHistory()
  }

  private handleImageActivitySelection = () => {
    // Image Activity requires manual input, so no automatic action
  }

  private handleSourceHistorySelection = () => {
    // Source History requires manual input, so no automatic action
  }

  private getArticleActivity = () => {
    this.setState({isLoading: true, data: null, error: ''}, () =>
    AjaxWrapper
      .ajax(`${AjaxWrapper.getServerUrl()}/cs/${this.state.selectedCommunity}/article-activity`, HttpMethod.POST, {
        url: this.state.url,
      })
      .then((response: Types.ActivityReportResult) => {
        if (response.success) {
          this.setState({
            data: response,
          })
        } else {
          this.setState({
            error: response.message || 'Unknown Error',
          })
        }
        this.setState({
          isLoading: false,
        })
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('err', err)
        this.setState({
          error: (err.response || {message: 'Unknown Error'}).message,
          isLoading: false,
        })
      }))
  }

  private getScheduleHistory = () => {
    this.setState({isLoading: true, data: null, error: ''}, () =>
    AjaxWrapper
      .ajax(`${AjaxWrapper.getServerUrl()}/cs/${this.state.selectedCommunity}/schedule-history`, HttpMethod.POST, {})
      .then((response: Types.ActivityReportResult) => {
        if (response.success) {
          this.setState({
            data: response,
          })
        } else {
          this.setState({
            error: response.message || 'Unknown Error',
          })
        }
        this.setState({
          isLoading: false,
        })
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('err', err)
        this.setState({
          error: (err.response || {message: 'Unknown Error'}).message,
          isLoading: false,
        })
      }))
  }

  private getImageActivity = () => {
    this.setState({isLoading: true, data: null, error: ''}, () =>
    AjaxWrapper
      .ajax(`${AjaxWrapper.getServerUrl()}/cs/${this.state.selectedCommunity}/image-activity`, HttpMethod.POST, {
        url: this.state.url,
      })
      .then((response: Types.ActivityReportResult) => {
        if (response.success) {
          this.setState({
            data: response,
          })
        } else {
          this.setState({
            error: response.message || 'Unknown Error',
          })
        }
        this.setState({
          isLoading: false,
        })
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('err', err)
        this.setState({
          error: (err.response || {message: 'Unknown Error'}).message,
          isLoading: false,
        })
      }))
  }

  private getSourceHistory = () => {
    this.setState({isLoading: true, data: null, error: ''}, () =>
    AjaxWrapper
      .ajax(`${AjaxWrapper.getServerUrl()}/cs/${this.state.selectedCommunity}/source-history`, HttpMethod.POST, {
        url: this.state.url,
        limit: 10
      })
      .then((response: Types.ActivityReportResult) => {
        if (response.success) {
          this.setState({
            data: response,
          })
        } else {
          this.setState({
            error: response.message || 'Unknown Error',
          })
        }
        this.setState({
          isLoading: false,
        })
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('err', err)
        this.setState({
          error: (err.response || {message: 'Unknown Error'}).message,
          isLoading: false,
        })
      }))
  }

  private downloadSourceFile = (sourceId: number, sourceRunId: number) => {
    this.setState({isLoading: true})
    const url = `${AjaxWrapper.getServerUrl()}/cs/${this.state.selectedCommunity}/download-source-history/${sourceId}/${sourceRunId}`
    AjaxWrapper.ajax(url, HttpMethod.GET, null)
      .then((response: {content: string}) => {
        if (response.content) {
          const tryParseJson = (str: string) => {
            try {
              return JSON.parse(str)
            } catch (e) {
              return {}
            }
          }
          const downloadTextFile = (content: string, extension: string, filename: string) => {
            const element = document.createElement('a')
            const file = new Blob([content], { type: 'text/plain' })
            element.href = URL.createObjectURL(file)
            element.download = filename
            document.body.appendChild(element)
            element.click()
            document.body.removeChild(element)
          }
          let fileExtension = 'xml'
          if (Object.keys(tryParseJson(response.content)).length > 0) {
            fileExtension = 'json'
          }
          downloadTextFile(response.content, fileExtension, `${sourceRunId}.${fileExtension}`)
        } else {
          this.context.store.dispatch(Flash.showFlashError('File not found.'))
        }
        this.setState({
          isLoading: false,
        })
      }).catch((err) => {
      this.context.store.dispatch(Flash.showFlashError('File not found.'))
      this.setState({
        isLoading: false,
      })
    })
  }
}

export const ActivityReport = GenericRedux.createConnect(ActivityReportComponent, Constants.REDUX_STORE_HOME)
injectReducer(
  Constants.REDUX_STORE_HOME,
  Redux.combineReducers({
    data: GenericRedux.createGenericReducer(Constants.REDUX_STORE_HOME, {}),
  }),
)